import React, { useMemo, useContext, useState, useEffect } from "react";
import styles from "@/page-components/RightSizing/rightSizing.module.css";
import {
  FilterSearch,
  FilterSearchToggle,
} from "@/components/filter-search/filter-search";
import { Button } from "react-bootstrap";
import add from "@/assets/img/add.svg";
import { useNavigate } from "react-router-dom";
import { RiContexts } from "../../right.context";
import { useFilterOptions } from "@/services/rightRecommendation/rightrec-filter.repo";
import TagItem from "./recom-tag.part";

const FilterSection = ({ service, name }) => {
  const context = useContext(RiContexts);
  const [isAddButtonDisabled, setIsAddButtonDisabled] = useState(true);
  const selectedAccountIds = (context.selectedAccounts || []).map((e) => e.id);
  const res = useMemo(() => {
    return {
      service,
      accounts: context?.selectedAccounts?.length
        ? context.selectedAccounts.map((e) => e.id)
        : undefined,
    };
  }, [service, context?.selectedAccounts]);
  const dropdown = useFilterOptions(res);

  useEffect(() => {
    const disableAddButton = context.selectedTags.some(
      (tag) => tag.filterOn === "" || tag.values.length === 0
    );
    setIsAddButtonDisabled(disableAddButton);
  }, [context.selectedTags]);

  return (
    <>
      <div className={styles.filter_main_div} style={{ minWidth: 0 }}>
        <Filter
          tittle={name}
          data={dropdown?.data?.accounts}
          isLoading={dropdown?.isLoading}
          filterType="account"
          selectedValues={context?.selectedAccounts}
          onSelect={(list) => {
            context?.setSelectedAccount(list);
          }}
          onRemove={(list) => {
            context?.setSelectedAccount(list);
          }}
        />

        {service === "azure" && context?.selectedAccounts?.length > 0 && (
          <Filter
            tittle={"Resource Group"}
            data={dropdown?.data?.resourceGroupName}
            isLoading={dropdown?.isLoading}
            filterType="resourcegroupname"
            selectedValues={context.selectedResourceGroup}
            onSelect={(list) => {
              context?.setSelectedResourceGroup(list);
            }}
            onRemove={(list) => {
              context?.setSelectedResourceGroup(list);
            }}
          />
        )}

        <Filter
          tittle={"Region"}
          data={dropdown?.data?.regions}
          isLoading={dropdown?.isLoading}
          filterType="region"
          selectedValues={context.selectedRegions}
          onSelect={(list) => {
            context?.setSelectedRegions(list);
          }}
          onRemove={(list) => {
            context?.setSelectedRegions(list);
          }}
        />

        <hr className="w-100 mb-0" />

        <div className={styles.filter_box_div}>
          <div className={styles.filter_name_addsign}>
            <div className={styles.filter_name}>Tags</div>
            <Button
              variant="link"
              className="p-0"
              onClick={() => {
                context?.setSelectedTags((arr) => {
                  const newArr = [...arr];
                  newArr.push({
                    filterOn: "",
                    filterType: "include",
                    values: [],
                  });
                  return newArr;
                });
              }}
              disabled={isAddButtonDisabled}
              style={{
                opacity: isAddButtonDisabled ? 0.4 : "",
                fill: isAddButtonDisabled ? "#CED4DA" : "",
                pointerEvents: isAddButtonDisabled ? "none" : "auto",
              }}
            >
              <img src={add} alt="" />
            </Button>
          </div>
          {context?.selectedTags.map((tag, index) => (
            <TagItem service={service} tag={tag} index={index} />
          ))}
        </div>
      </div>
    </>
  );
};

const Filter = ({ tittle, data, isLoading, filterType, selectedValues }) => {
  const context = useContext(RiContexts);
  const [tempSelectedValues, setTempSelectedValues] = useState([]);
  const [currentSelectedValues, setCurrentSelectedValues] = useState([]);
  const [applyTrue, setApplyTrue] = useState(false);

  const handleSelect = (selectedList) => {
    if (filterType === "account") {
      context.setSelectedAccount(selectedList);
    }
    if (filterType === "resourcegroupname") {
      context.setSelectedResourceGroup(selectedList);
    }
    if (filterType === "region") {
      context.setSelectedRegions(selectedList);
    }
  };

  const handleRemove = (selectedList) => {
    handleSelect(selectedList);
  };

  const handleTittle = (title) => {
    if (title === "Subscription") {
      title = "Account";
    }
    // setSelectedTittle(title?.toLowerCase());
  };

  const navigate = useNavigate();
  const handleTagSelection = () => {
    // Reset page to 1 when a filter is selected
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("page", "1");
    navigate(`?${searchParams.toString()}`);
  };

  const handleApply = () => {
    handleSelect(tempSelectedValues);
    setCurrentSelectedValues(tempSelectedValues);
  };

  const handleCancel = () => {
    setTempSelectedValues(currentSelectedValues);
  };

  useEffect(() => {
    setTempSelectedValues(selectedValues);
    setCurrentSelectedValues(selectedValues);
  }, [selectedValues]);

  return (
    <>
      <div className={styles.filter_padding_div}>
        <div className={styles.dimension_div}>
          <div className={styles.dimension_name_css}>{tittle}</div>
          <div
            onClick={() => handleTittle(tittle)}
            className={styles.filter_group_name_css}
          >
            <FilterSearch
              multiselect={true}
              showApply
              applyTrue={applyTrue}
              setApplyTrue={setApplyTrue}
              loading={isLoading}
              options={(data || []).map((e) => {
                return {
                  id: e.accountId || e.regionId || e.resourceGroup,
                  name: e.accountName || e.regionName || e.resourceGroupName,
                };
              })}
              // selectedValues={selectedValues || []}
              // onSelect={(list) => {
              //   handleTagSelection();
              //   handleRemove(list);
              // }}
              // onRemove={(list) => {
              //   handleRemove(list);
              // }}
              selectedValues={tempSelectedValues || []}
              onSelect={(list) => {
                setTempSelectedValues(list);
                handleTagSelection();
              }}
              onRemove={(list) => setTempSelectedValues(list)}
              displayValue="name"
              placeholder="--Select--"
              toggle={
                <>
                  <FilterSearchToggle placeholder={tittle} />
                </>
              }
              onCancel={() => {
                handleCancel();
              }}
              onApply={() => {
                handleApply();
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterSection;
